import React from "react";
import Box from "@mui/joy/Box";
import Sheet from "@mui/joy/Sheet";

interface DrawerWrapperProps {
  readonly children: React.ReactNode;
}

export function DrawerWrapper({ children }: DrawerWrapperProps) {
  return (
    <Box
      sx={{
        width: "450px",
        position: "fixed",
        right: 0,
        top: 0,
        zIndex: 1000,
      }}
    >
      <Sheet
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "450px",
          borderLeft: "1px solid",
          borderColor: "divider",
          height: "100vh",
        }}
      >
        {children}
      </Sheet>
    </Box>
  );
}
